import { del, get, post, put } from "helpers/api_helper/Authentication/authenticationApiHelper"
import * as url from "helpers/url_helper/url_helper"


export const getMemberDefinitions = () => get(url.MEMBER_DEFINITIONS)
export const addNewMemberDefinition = memberDefinition => post(url.MEMBER_INSERT, memberDefinition)
export const updateMemberDefinition = memberDefinition => put(url.MEMBER_UPDATE, memberDefinition)
export const deleteMemberDefinition = guid => del(`${url.MEMBER_DELETE}/${guid}`, { params: { guid } })
